import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_HR_CONTRACT_SUBSCRIPTION, MY_HR_GET_CONTRACT } from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";

export const useMyHrContract = ({ contract }: { contract: string | null }) => {
  const { data, loading, error, refetch } = useQuery(MY_HR_GET_CONTRACT, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
    skip: !contract,
    variables: { contract },
  });

  useSubscription(MY_HR_CONTRACT_SUBSCRIPTION, {
    onData: () => {
      refetch();
    },
  });

  return { data: data?.contract, loading, error };
};

export default useMyHrContract;
